import { Link } from 'react-router-dom';
import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';

export default function LaundryService() {
  const services = [
    {
      icon: 'ri-shirt-line',
      title: 'Lessive à Domicile',
      description: 'Service complet de lavage avec collecte et livraison',
      price: 'À partir de 8€/kg',
      features: [
        'Collecte gratuite à domicile',
        'Tri professionnel par couleur et matière',
        'Lavage avec produits de qualité',
        'Séchage optimal selon le textile',
        'Livraison soignée sous 48h',
        'Emballage protection inclus'
      ]
    },
    {
      icon: 'ri-iron-line',
      title: 'Repassage Professionnel',
      description: 'Repassage expert pour tous vos vêtements',
      price: 'À partir de 15€/h',
      features: [
        'Techniques de repassage expertes',
        'Finition impeccable garantie',
        'Pliage soigné et méticuleux',
        'Traitement anti-plis longue durée',
        'Emballage protection premium',
        'Service express disponible'
      ]
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Nettoyage à Sec',
      description: 'Traitement spécialisé pour vêtements délicats',
      price: 'Sur devis',
      features: [
        'Tissus délicats et précieux',
        'Costumes et tailleurs',
        'Robes de soirée et céremonie',
        'Cuir, daim et fourrure',
        'Élimination taches tenaces',
        'Retouches mineures incluses'
      ]
    }
  ];

  const textileTypes = [
    {
      category: 'Vêtements Quotidiens',
      items: ['T-shirts et chemises', 'Pantalons et jeans', 'Pulls et gilets', 'Sous-vêtements']
    },
    {
      category: 'Linge de Maison',
      items: ['Draps et housses', 'Serviettes de bain', 'Rideaux et voilages', 'Nappes et sets']
    },
    {
      category: 'Vêtements Professionnels',
      items: ['Costumes et tailleurs', 'Chemises de bureau', 'Blouses médicales', 'Uniformes']
    },
    {
      category: 'Articles Délicats',
      items: ['Soie et dentelle', 'Laine et cachemire', 'Cuir et daim', 'Accessoires mode']
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50/30">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative py-24 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(147, 51, 234, 0.8), rgba(126, 34, 206, 0.8)), url('https://readdy.ai/api/search-image?query=Professional%20laundry%20and%20ironing%20service%20with%20clean%20folded%20clothes%2C%20modern%20laundry%20equipment%2C%20steam%20iron%2C%20purple%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20fresh%20clean%20garments%2C%20professional%20laundry%20setup%2C%20bright%20clean%20environment%2C%20washing%20machines%20and%20ironing%20station&width=1920&height=800&seq=laundry-hero&orientation=landscape')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <div className="mb-6">
            <Link to="/" className="inline-flex items-center text-purple-200 hover:text-white transition-colors cursor-pointer">
              <i className="ri-arrow-left-line mr-2"></i>
              Retour à l'accueil
            </Link>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            Lessive & Repassage
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto">
            Prise en charge complète de votre linge avec service à domicile
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={scrollToContact}
              className="bg-white text-purple-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              Réserver Service
            </button>
            <button
              onClick={() => window.location.href = 'tel:+14384081200'}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-purple-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              438 408 1200
            </button>
          </div>
        </div>
      </section>

      {/* Services détaillés */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Nos Services Lessive & Repassage
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Solutions complètes pour l'entretien de tous vos textiles
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
                <div 
                  className="h-48 bg-cover bg-center relative"
                  style={{
                    backgroundImage: `url('https://readdy.ai/api/search-image?query=Professional%20laundry%20service%20$%7Bservice.title.toLowerCase%28%29%7D%20with%20clean%20folded%20clothes%2C%20modern%20equipment%2C%20purple%20and%20white%20color%20scheme%2C%20high%20quality%20photography%2C%20fresh%20garments%2C%20professional%20setup%2C%20bright%20environment&width=600&height=400&seq=laundry-detail-${index}&orientation=landscape')`
                  }}
                >
                  <div className="absolute inset-0 bg-purple-600/20"></div>
                  <div className="absolute top-4 left-4 w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-start mb-4">
                    <h3 className="text-2xl font-bold text-gray-900">{service.title}</h3>
                    <span className="text-lg font-semibold text-purple-600">{service.price}</span>
                  </div>
                  
                  <p className="text-gray-600 mb-6">{service.description}</p>
                  
                  <ul className="space-y-3 mb-6">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <i className="ri-check-line text-purple-500 mr-3 mt-1"></i>
                        <span className="text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <button
                    onClick={scrollToContact}
                    className="w-full bg-purple-600 text-white py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Réserver ce service
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Types de textiles */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Tous Types de Textiles
            </h2>
            <p className="text-xl text-gray-600">
              Nous prenons soin de tous vos vêtements et linges
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {textileTypes.map((type, index) => (
              <div key={index} className="bg-white rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h3 className="text-lg font-semibold mb-4 text-purple-600">{type.category}</h3>
                <ul className="space-y-2">
                  {type.items.map((item, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-purple-500 mr-2"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processus */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Notre Processus en 4 Étapes
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { step: '1', title: 'Collecte', description: 'Récupération gratuite à domicile selon votre planning', icon: 'ri-truck-line' },
              { step: '2', title: 'Traitement', description: 'Tri, lavage et repassage avec expertise professionnelle', icon: 'ri-settings-line' },
              { step: '3', title: 'Contrôle', description: 'Vérification qualité et emballage soigné', icon: 'ri-shield-check-line' },
              { step: '4', title: 'Livraison', description: 'Retour impeccable sous 24-48h', icon: 'ri-home-line' }
            ].map((process, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${process.icon} text-2xl text-white`}></i>
                </div>
                <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-purple-600 font-bold">{process.step}</span>
                </div>
                <h3 className="text-xl font-semibold mb-3">{process.title}</h3>
                <p className="text-gray-600">{process.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}